/***
 *
 *   RESET PASSWORD
 *   User can set a new password using the token
 *
 **********/

import {
  Animate,
  AuthContext,
  Card,
  Form,
  Row,
  useLocation,
  useNavigate,
} from "components/lib";
import { useContext } from "react";
import logo from "./images/black_logo.png";
import styles from "./styles2.module.scss";

export function ResetPassword(props) {
  // context
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(AuthContext);

  // check for token
  const qs = location.search;
  const token = qs.substring(qs.indexOf("?token=") + 7);

  return (
    <Animate type="pop">
      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.header}>
            <img src={logo} alt="Logo" />
          </div>
          <div className={styles.wrapper}>
            <Row title="Reset Your Password">
              <Card restrictWidth center>
                <Form
                  inputs={{
                    jwt: {
                      type: "hidden",
                      value: token,
                    },
                    email: {
                      label: "Email",
                      type: "email",
                      required: true,
                    },
                    password: {
                      label: "New Password",
                      type: "password",
                      required: true,
                      complexPassword: true,
                    },
                  }}
                  url="/api/auth/password/reset"
                  method="POST"
                  buttonText="Set New Password"
                  callback={(res) => {
                    res.data["2fa_required"]
                      ? navigate(`/app/signin/otp?token=${res.data.token}`)
                      : context.signin(res);
                  }}
                />
              </Card>
            </Row>
          </div>
          <div className={styles.footer}>Coverbadger ©2025</div>
        </div>
      </div>
    </Animate>
  );
}
